export const KHBanks = [
  { value: '001', bank_code: '001', bank_name: 'ធនាគារ អេប៊ីអេ​', bank_name_en: 'ABA Bank' },
  { value: '002', bank_code: '002', bank_name: 'ធនាគារ អេស៊ីលីដា', bank_name_en: 'ACLEDA Bank' },
  { value: '003', bank_code: '003', bank_name: 'ធនាគារ វីង : (Wing Bank)', bank_name_en: 'Wing Bank' },
  { value: '004', bank_code: '004', bank_name: 'TRUEMONEY', bank_name_en: 'TRUEMONEY' },
];

export default KHBanks;
